import {AchievedRecord} from "./AchievedRecord";

/*
 achievement:
  time:
    lastResult:
      date: 2022-04-01
      value: 4
    lastDates:
      0:
        date: 2022-04-01
        continuous: 2
        maxContinuous: 3
      10:
  jogging-dist:
    lastAchieved: 100
    count: 180
 */

const list10 = new Array(9).fill(null).map((_,i) => (i+1)*10)
const list100 = new Array(10).fill(null).map((_,i) => (i+1)*100)
export const CONTINUOUS_ACHIEVE_TYPE = {
  'time': []
    .concat(new Array(7).fill(null).map((_,i) => i*5*60))
    .concat([3600, 4800, 7200]),
  'seiken-continuousCount': [1, 10, 50, 100, 300, 500, 1000, 3000, 5000, 10000],
  'crunch-continuousCount': [1, 3].concat(list10).concat(list100),
  'squat-continuousCount': [1, 3].concat(list10).concat(list100),
  'dumbbell-curl-continuousCount': [1].concat(list10).concat(list100),
}

export class ContinuousAchieveDetector {
  constructor(cache) {
    this.cache = cache
    this.onAchieved = null
  }

  checkContinuousType(date, type, diff) {
    let cachedObj = this.cache.getCache(type)
    cachedObj = this.updateLastResult(date, cachedObj, diff)
    CONTINUOUS_ACHIEVE_TYPE[type].forEach(
      goal => this.updateLastDates(date, type, cachedObj, goal)
    )
  }

  updateLastResult(date, cachedObj, diff) {
    let lastResult = cachedObj['lastResult'] || {}
    if (lastResult['date'] !== date) {
      lastResult = { date, value: 0 }
    }
    lastResult.value += diff
    cachedObj['lastResult'] = lastResult
    return cachedObj
  }

  updateLastDates(date, type, cachedObj, goal) {
    let lastResult = cachedObj['lastResult'] || {}
    let lastDates = cachedObj['lastDates'] || {}
    let perMinutes = lastDates[goal.toString()]  || { date: null, continuous: 0, maxContinuous: 0, achievedTime: null }
    if (goal <= lastResult.value && (perMinutes['date'] || null) !== date) {
      const passedSec = new Date(date).getTime() - new Date(perMinutes['date']).getTime()
      if (!perMinutes['date'] || passedSec > 24 * 60 * 60 * 1000) {
        perMinutes['continuous'] = 1
      } else {
        perMinutes['continuous']++
      }
      perMinutes['date'] = date
      let newRecord = false
      if (perMinutes['continuous'] > perMinutes['maxContinuous']) {
        perMinutes['maxContinuous'] = perMinutes['continuous']
        perMinutes['achievedTime'] = new Date().getTime()
        newRecord = true
      }
      lastDates[goal.toString()] = perMinutes
      if (this.onAchieved && newRecord) {
        this.onAchieved({ type, goal, continuous: perMinutes['continuous'] })
      }
    }
    cachedObj['lastDates'] = lastDates
    this.cache.setCache(type, cachedObj)
  }

  getAchievements() {
    const achievements = []
    Object.keys(CONTINUOUS_ACHIEVE_TYPE).forEach(type => {
      let cachedObj = this.cache.getCache(type)
      const lastDates = cachedObj['lastDates']
      if (lastDates) {
        let preContinuous = 0
        // 後ろから見ていき、大きいゴールより継続日数が長い時だけ追加
        Object.keys(lastDates).sort().reverse().forEach(goal => {
          const continuous = lastDates[goal]['continuous']
          if (preContinuous < lastDates[goal]['continuous']) {
            achievements.push(new AchievedRecord({ type, goal, continuous }))
            preContinuous = continuous
          }
        })
      }
    })
    return achievements
  }
}



// WEBPACK FOOTER //
// ./src/components/common/achievement/ContinuousAchieveDetector.js